import { createContext } from 'react';

const DonationFormContext = createContext(null);

export default DonationFormContext;
